import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import type { StepGroup } from '../../types/application';
interface SectionRailProps {
  groups: StepGroup[];
  activeStep: string;
  completed: string[];
}
export function SectionRail({
  groups,
  activeStep,
  completed
}: SectionRailProps) {
  return <nav aria-label="Application sections" data-id="element-40" data-mp="1t824ri2txj1h">
      <ol className="space-y-1" data-id="element-41" data-mp="1t8vdupp9gkms">
        {groups.map(g => {
        const active = g.steps.some(s => s.id === activeStep);
        const done = g.steps.every(s => completed.includes(s.id));
        const doneCount = g.steps.filter(s => completed.includes(s.id)).length;
        return <li key={g.id} data-id="element-42" data-mp="1y6dfrw4v1zla">
              <div className={`flex items-center gap-3 rounded-xl px-3 py-2.5 ${active ? 'bg-white shadow-soft ring-1 ring-ink-200/70' : ''}`} data-id="element-43" data-mp="3ely7wq2jsw38">
                <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-full text-[11px] font-semibold transition-colors duration-200 ${done ? 'bg-pulse-600 text-white' : active ? 'bg-ink-900 text-white' : 'bg-ink-200 text-ink-500'}`} aria-hidden data-id="element-44" data-mp="39m21kk6doski">
                  <AnimatePresence mode="wait" initial={false} data-id="element-45" data-mp="3df97fs4eiqd6">
                    {done ? <motion.span key="c" initial={{
                  scale: 0.4,
                  opacity: 0
                }} animate={{
                  scale: 1,
                  opacity: 1
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-46" data-mp="2frimkrmfymz1">
                        <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-47" data-mp="2kohd706wcbsh" />
                      </motion.span> : <motion.span key="n" initial={{
                  opacity: 0
                }} animate={{
                  opacity: 1
                }} data-id="element-48" data-mp="2ugwtzu6giubs">
                        {doneCount}/{g.steps.length}
                      </motion.span>}
                  </AnimatePresence>
                </span>
                <span className={`flex-1 text-[15px] ${active ? 'font-semibold text-ink-900' : done ? 'text-ink-700' : 'text-ink-500'}`} data-id="element-49" data-mp="21xzmt29jdsaa">{g.label}</span>
              </div>
              <AnimatePresence initial={false} data-id="element-50" data-mp="1ozjrq5gm909z">
                {active && g.steps.length > 1 && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-51" data-mp="23nwgoihadiuz">
                    <ol className="ml-6 mt-1 space-y-0.5 border-l border-ink-200 py-1 pl-4" data-id="element-52" data-mp="1kyq3faz9hjgk">
                      {g.steps.map(s => {
                  const isActive = s.id === activeStep;
                  const isDone = completed.includes(s.id);
                  return <li key={s.id} data-id="element-53" data-mp="2rf24pkxdrhgd">
                            <Link to={`/apply/${s.id}`} aria-current={isActive ? 'step' : undefined} className={`flex items-center justify-between rounded-lg px-2 py-1.5 text-sm transition-colors duration-150 ${isActive ? 'font-medium text-pulse-700' : isDone ? 'text-ink-500 hover:text-ink-900' : 'text-ink-400 hover:text-ink-700'}`} data-id="element-54" data-mp="2re0hyj7056it">
                              {s.label}
                              {isDone && !isActive && <CheckIcon className="h-3.5 w-3.5 text-pulse-500" aria-label="done" data-id="element-55" data-mp="3mo5h740elqch" />}
                            </Link>
                          </li>;
                })}
                    </ol>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ol>
    </nav>;
}